import { Switch } from "@mui/material";

import { RobotoTooltip } from "@/shared/components";
import { type TriggerV2Record } from "@/shared/domain/triggers";
import { useToggleTrigger } from "@/shared/domain/triggers/hooks";

/**
 * A trigger's Enabled switch in the triggers list. It shows the value a
 * toggle in flight is sending, and only it is disabled meanwhile.
 *
 * `onToggle` and `onError` come from the page, which reports a failure in its
 * alert.
 */
export function TriggerEnabledSwitch({
  trigger,
  onToggle,
  onError,
}: {
  trigger: TriggerV2Record;
  onToggle: () => void;
  onError: (error: Error) => void;
}) {
  const { checked, pending, toggle } = useToggleTrigger(trigger, onError);

  return (
    <RobotoTooltip title={checked ? "Disable trigger" : "Enable trigger"}>
      <Switch
        size="small"
        checked={checked}
        disabled={pending}
        onChange={(_event, enabled) => {
          onToggle();
          toggle(enabled);
        }}
        inputProps={{ role: "switch", "aria-label": `${trigger.name} enabled` }}
      />
    </RobotoTooltip>
  );
}
